import PlainStudentCard from './PlainStudentCard';

export default PlainStudentCard;
